module.exports = __webpack_public_path__ + "static/media/duva-min.746f41bc.png";